import { render, staticRenderFns } from "./detail-tab-resumo.vue?vue&type=template&id=6a88df80&"
import script from "./detail-tab-resumo.vue?vue&type=script&lang=js&"
export * from "./detail-tab-resumo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a88df80')) {
      api.createRecord('6a88df80', component.options)
    } else {
      api.reload('6a88df80', component.options)
    }
    module.hot.accept("./detail-tab-resumo.vue?vue&type=template&id=6a88df80&", function () {
      api.rerender('6a88df80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/components/detail-tab-resumo/detail-tab-resumo.vue"
export default component.exports